<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">农副产品</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              加拿大优美洁净的自然环境，加上当地人尊崇的节制、自然开发理念，为加拿大孕育优质绿色农副产品提供了重要保障。
              在这样优质的大环境中，我们精心挑选并代理了加拿大各省高品质、知名的农副产品。这些产品遍布于加拿大各大超市、免税店、便利店、礼品店等，
              历史悠久，得到了当地市场充分的信任。我们将产品原装采购回国，通过我们下单，我们将从国内库房直邮到家，让您轻松便捷地享受最健康的食品。
            </p>
          </div>
          <ProductGallery class="products" :products="productList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProductGallery from "@/components/products/ProductGallery.vue";
import { Tabs } from "@/components";
export default {
  name: "Food",
  components: {
    Tabs,
    ProductGallery
  },
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bgs/foodBanner.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/foodAvatar.jpg")
    }
  },
  computed: {
    ...mapGetters(["products"]),
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    productList() {
      return this.products.filter(item => item.product_category === 2);
    },
  },
  methods: {
    ...mapActions(["listProducts"])
  },
  mounted() {
    if (!this.products.length) {
      this.listProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.products {
  padding-bottom: 4rem;
}


</style>
